import { useMemo } from 'react';
import { useTranslation } from '@shared/core';

export const useTransformRatingToCategory = (rating?: number | null) => {
  const { t } = useTranslation('planningAccommodations');
  const { hotelItem } = t('browse');
  const ratingCategory = useMemo(() => {
    const normalizedRating = rating ?? 0;
    switch (true) {
      case normalizedRating >= 9:
        return hotelItem.ratingCategory.wonderful();
      case normalizedRating >= 8.5:
        return hotelItem.ratingCategory.fabulous();
      case normalizedRating >= 8:
        return hotelItem.ratingCategory.veryGood();
      case normalizedRating >= 7:
        return hotelItem.ratingCategory.good();
      case normalizedRating >= 6:
        return hotelItem.ratingCategory.pleasant();
      default:
        return '';
    }
  }, [rating, hotelItem.ratingCategory]);

  return ratingCategory;
};
